// extracted by mini-css-extract-plugin
export default {"closeBtn":"closeButton_closeBtn__DPdr6"};